module.exports = function () {

    var typeaheadHelper = require('./helpers/typeahead-helper.js');

    $(document).ready(function () {

        typeaheadHelper.typeaheadInitProperty(typeaheadHelper.engineProperty);

        /*************************************
         * TYPEAHEAD SELECTED PROPERTY EVENT *
         *************************************/
        $('.js-property-field-typeahead').bind('typeahead:select', function (ev, suggestions) {

            var $this = $(this),
                $field =  $this.parent().parent().find('.js-property-id-field');

            $field.val(suggestions.id);
            $("input[name='property_id']").val(suggestions.id);

        });
    });
}();
